import(/* webpackMode: "eager" */ "C:\\laragon\\www\\agrotechnusa\\src\\app\\tentang\\page.tsx");
